import * as Sentry from "@sentry/react";
import { isProduction } from "./env";
import axios from "axios";

export const handleError = (error: any, context: string = "") => {
  // If it's an Axios network error (no response), do not log to Sentry
  if (axios.isAxiosError(error) && !error.response) {
    console.warn(`Network error in ${context}:`, error.message);
    return;
  }

  if (isProduction) {
    Sentry.captureException(error, {
      tags: { context },
    });
  }
};
